document.addEventListener('DOMContentLoaded', () => {
  const resolveLengthPx = (articleRoot, rawValue) => {
    if (!rawValue) return 0;

    if (rawValue.endsWith('px')) return parseFloat(rawValue);
    if (rawValue.endsWith('rem')) {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      return parseFloat(rawValue) * rootFontSize;
    }

    const probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.height = rawValue;
    articleRoot.appendChild(probe);
    const resolved = probe.getBoundingClientRect().height;
    probe.remove();
    return resolved;
  };

  const resolveOffsetPx = (articleRoot) => {
    const rawGap = getComputedStyle(articleRoot).getPropertyValue('--editorial-anchor-gap').trim();
    const gap = resolveLengthPx(articleRoot, rawGap);
    const sectionHeader = document.querySelector('.section-header');
    const headerBottom = sectionHeader ? Math.max(sectionHeader.getBoundingClientRect().bottom, 0) : 0;

    return headerBottom + gap;
  };

  const resolveScrollTarget = (articleRoot, hash) => {
    if (!hash || hash === '#') return null;

    const target = articleRoot.querySelector(hash);
    if (!target) return null;

    if (target.matches('.editorial-article__rte section')) {
      return target.querySelector('h2, h3, h4, h5, h6') || target;
    }

    return target;
  };

  const buildEditorialToc = (articleRoot) => {
    const tocLists = articleRoot.querySelectorAll('.editorial-article__toc');
    if (!tocLists.length) return;

    const headings = Array.from(articleRoot.querySelectorAll('.editorial-article__rte h2[id]'));

    tocLists.forEach((tocList) => {
      tocList.innerHTML = '';

      if (!headings.length) {
        tocList.closest('.editorial-article__rail')?.setAttribute('hidden', 'hidden');
        return;
      }

      tocList.closest('.editorial-article__rail')?.removeAttribute('hidden');

      headings.forEach((heading) => {
        const label = heading.dataset.tocLabel?.trim() || heading.textContent?.trim();
        if (!label || !heading.id) return;

        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = label;
        listItem.appendChild(link);
        tocList.appendChild(listItem);
      });
    });
  };

  const bindEditorialArticle = (articleRoot) => {
    buildEditorialToc(articleRoot);

    const scrollToHash = (hash, smooth = true) => {
      if (!hash || hash === '#') return;

      const target = resolveScrollTarget(articleRoot, hash);
      if (!target) return;

      const offset = resolveOffsetPx(articleRoot);
      const top = Math.max(target.getBoundingClientRect().top + window.scrollY - offset, 0);

      window.scrollTo({
        top,
        behavior: smooth ? 'smooth' : 'auto',
      });
    };

    articleRoot.querySelectorAll('.editorial-article__toc a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const hash = link.getAttribute('href');
        if (!hash) return;

        const target = resolveScrollTarget(articleRoot, hash);
        if (!target) return;

        event.preventDefault();
        history.replaceState(null, '', hash);
        scrollToHash(hash, true);
      });
    });

    if (window.location.hash && articleRoot.querySelector(window.location.hash)) {
      requestAnimationFrame(() => {
        scrollToHash(window.location.hash, false);
      });
    }

    window.addEventListener('hashchange', () => {
      if (window.location.hash && articleRoot.querySelector(window.location.hash)) {
        scrollToHash(window.location.hash, false);
      }
    });
  };

  document.querySelectorAll('.editorial-article').forEach(bindEditorialArticle);
});
